import packageJson from '../package.json';

const asBool = (value: string | undefined): boolean => value === 'true';

export interface ConfigState {
    backend: {
        assetAdmin: string | undefined;
        appLoginService: string | undefined;
        iamApi: string | undefined;
        appLoginExpirationDays: number | undefined;
        serviceCareActivation: string | undefined;
    };
    external: {
        api: {
            tbm3: string;
            ocu3: string;
            manWebFleet: string;
        };
    };
    id: string | undefined;
    login: {
        authority: string | undefined;
        clientId: string | undefined;
        oauthScope: string[];
        mockAuthorization: boolean;
        mockLocale: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
    };
    serviceVersion: string;
    serviceEnvironment: string;
    enableMockServer: boolean;
    sentryToken: string | undefined;
    sentryModuleName: string;
    bookingRecommendationBaseUrl: string;
    eulaVersion: string;
}

export const config: ConfigState = {
    backend: {
        assetAdmin: import.meta.env.VITE_ASSET_ADMIN_BASE_URL,
        appLoginService: import.meta.env.VITE_APP_LOGIN_SERVICE,
        appLoginExpirationDays: import.meta.env.VITE_APP_LOGIN_EXPIRATION_DAYS,
        iamApi: import.meta.env.VITE_IAM_API_BASE_URL,
        serviceCareActivation: import.meta.env.VITE_SERVICE_CARE_ACTIVATION_BASE_URL,
    },
    external: {
        api: {
            tbm3: import.meta.env.VITE_APP_TBM3_BACKEND,
            ocu3: import.meta.env.VITE_APP_OCU3_BACKEND,
            manWebFleet: import.meta.env.VITE_APP_MAN_WEBFLEET_BACKEND,
        },
    },
    id: import.meta.env.VITE_ID,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
        oauthScope: [
            'openid',
            'profile',
            'email',
            'asset-administration.read',
            'asset-administration.write',
            'man-eula-status.read',
            'man-eula-status.write',
            'vehiclestate.read',
            'vehiclestate.write',
        ],
        mockAuthorization: import.meta.env.DEV,
        mockLocale: import.meta.env.VITE_LOGIN_MOCK_LOCALE,
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
    },
    serviceVersion: packageJson.version,
    serviceEnvironment: import.meta.env.MODE,
    enableMockServer: import.meta.env.DEV,
    sentryToken: import.meta.env.VITE_SENTRY_DSN,
    sentryModuleName: 'assetConnectorWeb',
    bookingRecommendationBaseUrl: import.meta.env.VITE_BOOKING_RECOMMENDATION_BASE_URL,
    eulaVersion: import.meta.env.VITE_EULA_VERSION || '1.0.0',
};
